module.exports = __webpack_public_path__ + "static/media/Svgplaypause720.b8d2d706.m4v";